import React from "react";
import { ModalWrapper } from "@/components/modals/modal-wrapper";
import { Loader2 } from "lucide-react";

interface VerificationLoadingModalProps {
  message?: string;
}

export const VerificationLoadingModal: React.FC<
  VerificationLoadingModalProps
> = ({ message = "인증 코드 확인 중..." }) => {
  return (
    <ModalWrapper className="bg-white rounded-[10px] p-8 w-[320px]">
      <div className="flex flex-col items-center gap-6">
        <Loader2 className="h-12 w-12 animate-spin text-neutral-600" />
        <div className="text-center space-y-2">
          <p className="label-1-normal-medium text-primary">{message}</p>
          <p className="caption-1-regular text-neutral-500">
            잠시만 기다려 주세요
          </p>
        </div>
      </div>
    </ModalWrapper>
  );
};
